document.addEventListener("DOMContentLoaded", () => {
    const FORM = document.getElementById('formConsultaPrecedenteQualificado');
    const TIPO_COOKIE = document.getElementById('tipoCookie');
    const TIPO_ELEMENT = document.getElementById('tipo');
    TIPO_ELEMENT.value = TIPO_COOKIE.value;

    if (TIPO_COOKIE) {
        $(TIPO_ELEMENT).selectpicker('refresh');
    }

    const NUMERO_COOKIE = document.getElementById('numeroCookie');
    const NUMERO_ELEMENT = document.getElementById('numero');
    NUMERO_ELEMENT.value = NUMERO_COOKIE.value;
    const NUMERO_PROCESSO_COOKIE = document.getElementById('numeroProcessoParadigmaCookie');
    const NUMERO_PROCESSO_ELEMENT = document.getElementById('numeroProcessoParadigma');
    NUMERO_PROCESSO_ELEMENT.value = NUMERO_PROCESSO_COOKIE.value;
    const LIMITE_SUSPENSAO_COOKIE = document.getElementById('limiteSuspensaoCookie');
    const LIMITE_SUSPENSAO_ELEMENT = document.getElementById('limiteSuspensao');
    LIMITE_SUSPENSAO_ELEMENT.value = LIMITE_SUSPENSAO_COOKIE.value;

    if (LIMITE_SUSPENSAO_COOKIE) {
        $(LIMITE_SUSPENSAO_ELEMENT).selectpicker('refresh');
    }

    const RAMO_DIREITO_COOKIE = document.getElementById('ramoDireitoCookie');
    const RAMO_DIREITO_ELEMENT = document.getElementById('ramoDireito');
    RAMO_DIREITO_ELEMENT.value = RAMO_DIREITO_COOKIE.value;

    if (RAMO_DIREITO_COOKIE) {
        $(RAMO_DIREITO_ELEMENT).selectpicker('refresh');
    }

    const DATA_AFETACAO_COOKIE = document.getElementById('dataAfetacaoCookie');
    const DATA_AFETACAO_ELEMENT = document.getElementById('dataAfetacaoInicio');
    DATA_AFETACAO_ELEMENT.value = DATA_AFETACAO_COOKIE.value;
    const DATA_DESAFETACAO_COOKIE = document.getElementById('dataDesafetacaoCookie');
    const DATA_DESAFETACAO_ELEMENT = document.getElementById('dataAfetacaoFim');
    DATA_DESAFETACAO_ELEMENT.value = DATA_DESAFETACAO_COOKIE.value;
    const DATA_TRANSITO_INICIO_COOKIE = document.getElementById('dataTransitoInicioCookie');
    const DATA_TRANSITO_INICIO_ELEMENT = document.getElementById('dataTransitoInicio');
    DATA_TRANSITO_INICIO_ELEMENT.value = DATA_TRANSITO_INICIO_COOKIE.value;
    const DATA_TRANSITO_FIM_COOKIE = document.getElementById('dataTransitoFimCookie');
    const DATA_TRANSITO_FIM_ELEMENT = document.getElementById('dataTransitoFim');
    DATA_TRANSITO_FIM_ELEMENT.value = DATA_TRANSITO_FIM_COOKIE.value;
    const QUESTAO_SUBMETIDA_COOKIE = document.getElementById('questaoSubmetidaCookie');
    const QUESTAO_SUBMETIDA_ELEMENT = document.getElementById('questaoSubmetida');
    QUESTAO_SUBMETIDA_ELEMENT.value = QUESTAO_SUBMETIDA_COOKIE.value;

    const COOKIES_MAP = [
        {field: 'tipo', element: TIPO_ELEMENT},
        {field: 'numero', element: NUMERO_ELEMENT},
        {field: 'numeroProcessoParadigma', element: NUMERO_PROCESSO_ELEMENT},
        {field: 'limiteSuspensao', element: LIMITE_SUSPENSAO_ELEMENT},
        {field: 'ramoDireito', element: RAMO_DIREITO_ELEMENT},
        {field: 'dataAfetacao', element: DATA_AFETACAO_ELEMENT},
        {field: 'dataDesafetacao', element: DATA_DESAFETACAO_ELEMENT},
        {field: 'dataTransitoInicio', element: DATA_TRANSITO_INICIO_ELEMENT},
        {field: 'dataTransitoFim', element: DATA_TRANSITO_FIM_ELEMENT},
        {field: 'questaoSubmetida', element: QUESTAO_SUBMETIDA_ELEMENT}
    ];

    FORM.addEventListener('submit', event => {
        event.preventDefault();
        COOKIES_MAP.forEach(item => setCookie(item.field, item.element.value));
        salvarAssuntos();
        $('#listagemPrecedentesQualificados').DataTable().ajax.reload();
    });

    FORM.addEventListener('reset', () => {
        $('#tipo, #situacao, #limiteSuspensao, #ramoDireito').val('').selectpicker('refresh');

        const ELEMENTS_TO_CLEAR = [
            TIPO_ELEMENT,
            NUMERO_ELEMENT,
            NUMERO_PROCESSO_ELEMENT,
            LIMITE_SUSPENSAO_ELEMENT,
            RAMO_DIREITO_ELEMENT,
            DATA_AFETACAO_ELEMENT,
            DATA_DESAFETACAO_ELEMENT,
            DATA_TRANSITO_INICIO_ELEMENT,
            DATA_TRANSITO_FIM_ELEMENT,
            QUESTAO_SUBMETIDA_ELEMENT
        ];

        ELEMENTS_TO_CLEAR.forEach((e) => e.value = '');
        COOKIES_MAP.forEach(item => setCookie(item.field, ''));
        setCookie('assuntos', '');
    });

    function salvarAssuntos() {
        const assuntos = [];

        document.querySelectorAll('input[name^="assuntos_value["][name$="[CodMniAssuntoJudicial]"]').forEach(input => {
            const codigo = input.value;

            const descricao = document.querySelector(
                `input[name="assuntos_value[${codigo}][CodDesMniAssuntoJudicial]"]`);

            if (descricao) {
                assuntos.push({
                    CodMniAssuntoJudicial: codigo,
                    CodDesMniAssuntoJudicial: descricao.value
                });
            }
        });

        setCookie('assuntos', JSON.stringify(assuntos));
    }

    function setCookie(field, value) {
        document.cookie = 'precedenteQualificadoPublico_' + field + '=' + encodeURIComponent(value);
    }
});

window.renderNumeroPrecedenteQualificado = function(input) {
    return input.NumProcesso + input.DesAssuntoDescricaoCompleta;
}